import './Contact.css';
import { useState } from 'react';
import linkedIn from "../../../media/Icons/linkedin.png";
import instagram from "../../../media/Icons/instagram.png";
import gmail from "../../../media/Icons/gmail.png";

const DOG_IMAGES = [
  require("../../../media/Textures/Dogs/daisy.png"),
  require("../../../media/Textures/Dogs/golden.png"),
  require("../../../media/Textures/Dogs/jerry.png"),
  require("../../../media/Textures/Dogs/lexi.png"),
  require("../../../media/Textures/Dogs/oscar.png"),
  require("../../../media/Textures/Dogs/sandy.png"),
  require("../../../media/Textures/Dogs/sheapard.png")
];

function getRandomDog(currentDog) {
  const options = DOG_IMAGES.filter(img => img !== currentDog);
  return options[Math.floor(Math.random() * options.length)];
}

function Contact({ currentDog }) {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    message: ''
  });

  const [sent, setSent] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { firstName, lastName, email, message } = formData;
    window.location.href = `mailto:christinaverton04@gmail.com?subject=Message from ${firstName} ${lastName}&body=${message}%0A%0AFrom: ${email}`;
    console.log(formData);
    setSent(true);
  };

  return (
    <section className="Contact">
      <div className="socials">
        <h2>Socials</h2>
        <div className="social-media">
          <a href="https://www.linkedin.com/in/christina-verton-017574257/" target="_blank" rel="noreferrer">
            <img src={linkedIn} alt="LinkedIn" />
            LinkedIn
          </a>
          <a href="https://www.instagram.com/decaying.oranges?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noreferrer">
            <img src={instagram} alt="Instagram" />
            Instagram
          </a>
        </div>
        <div className="email-access">
          <p>If you don't want to email me here...</p>
          <a href="mailto:christinaverton04@gmail.com" target="_blank" rel="noreferrer">
            <img src={gmail} alt="Gmail" />
          </a>
          <a href="mailto:christinaverton04@gmail.com" target="_blank" rel="noreferrer">
            christinaverton04@gmail.com
          </a>
        </div>
      </div>

      <div className="email-form">
        <h3>Send a Message</h3>
        {sent ? (
          <div className="sent-msg-data">
            <p className="sent-msg">Thanks!<br /> Your email client should have opened</p>
            <img src={getRandomDog(currentDog)} alt="Current Dog" className="daisy" />
          </div>
        ) : (
          <div className="form">
            <div className="name-data">
              <input name="firstName" placeholder="First Name" value={formData.firstName} onChange={handleChange} />
              <input name="lastName" placeholder="Last Name" value={formData.lastName} onChange={handleChange} />
            </div>
            <input name="email" placeholder="Your Email" value={formData.email} onChange={handleChange} />
            <textarea name="message" placeholder="Your Message" rows="5" value={formData.message} onChange={handleChange} />
            <button id="form-button" onClick={handleSubmit}>Send</button>
          </div>
        )}
      </div>
    </section>
  );
}

export default Contact;
